import {

  PullRequestOutlined,
  QuestionCircleOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Layout, Menu } from "antd";
import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import CheckPermission from "../../../Util/CheckPermission";
import { connect } from "react-redux";
import { VerifiedUserOutlined } from "@mui/icons-material";

const Permissions = ({permissions}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedNav, setSelectedNav] = useState("");

  let items = [];
  if (CheckPermission("users_status_list", permissions)) {
    items.push({
      icon: <UserOutlined />,
      label: <Link to="/permissions/admins">ادمین‌ها</Link>,
      key: "admins",
    });
    items.push({
      icon: <VerifiedUserOutlined />,
      label: <Link to="/permissions/roles">نقش‌ها</Link>,
      key: "roles",
    })
  }
 

  useEffect(() => {
    if (location.pathname === "/permissions") {
      navigate("/permissions/admins");
      setSelectedNav("");
      // setTimeout(()=>{
      //   setSelectedNav('')
      // } , 1)
    }
    items.forEach((el) => {
      if (!el) {
        return;
      }
      if (`/permissions/${el.key}` == location.pathname) {
        setSelectedNav(el.key);
      }
    });
  }, [location]);

  return (
    <Layout
      style={{
        padding: "24px 0",
        background: "white",
      }}
    >
      <Layout.Sider
        style={{
          background: "white",
        }}
        width={200}
      >
        <Menu
          mode="inline"
          selectedKeys={[selectedNav]}
          style={{
            height: "100%",
          }}
          items={items}
        />
      </Layout.Sider>
      <Layout.Content
        style={{
          padding: "0 24px",
          height: "100%",
          borderRadius: "6px",
        }}
      >
        <Outlet />
      </Layout.Content>
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    permissions: state.userData ? state.userData.permissions : [],
  };
};
export default connect(mapStateToProps)(Permissions);
